import { DataGrid } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import axiosInstance from "utils/axiosInstance";

const EquityBasketTable = () => {
  const { data: advisorList, isFetching } = useQuery({
    queryKey: ["MODAL_PORTFOLIO"],
    queryFn: () => axiosInstance.get(`/super_admin/model-portfolios/`, {}),
    onError: (err) => {
      // setShowAlert({
      //   type: "error",
      //   show: true,
      //   message: err?.response?.data?.message || "Something went wrong",
      // });
    },
  });

  const columns = [
    {
      headerName: "Name",
      field: "name",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
      valueGetter: (row) => row || "-",
    },
    {
      headerName: "Advisor Name",
      field: "advisor",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
      valueGetter: (row) => row || "-",
    },
    {
      headerName: "Versions",
      field: "versionsCount",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 200,
      type: "number",
      valueGetter: (row) => row || 0,
    },
    {
      headerName: "Mapped Portfolios",
      field: "mappedPortfoliosCount",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
      type: "number",
      valueGetter: (row) => row || 0,
    },
    {
      headerName: "Unique Item",
      field: "uniqueItemCount",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
      type: "number",
      valueGetter: (row) => row || 0,
    },
    {
      headerName: "Total Orders",
      field: "ordersCount",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
      type: "number",
      valueGetter: (row) => row || 0,
    },
    {
      headerName: "Allocation",
      field: "allocationCount",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
      type: "number",
      valueGetter: (row) => row || 0,
    },
    {
      headerName: "Rebalance",
      field: "rebalanceCount",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
      type: "number",
      valueGetter: (row) => row || 0,
    },
    {
      headerName: "Exit",
      field: "exitCount",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
      type: "number",
      valueGetter: (row) => row || 0,
    },
    {
      headerName: "Company Wise Exit",
      field: "cwexitCount",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
      type: "number",
      valueGetter: (row) => row || 0,
    },
  ];

  console.log(
    advisorList?.data?.data.map((dataItem, index) => {
      return {
        ...dataItem,
        id: index,
      };
    })
  );
  return (
    <DataGrid
      autoHeight
      loading={isFetching}
      columns={columns}
      rows={
        advisorList?.data?.data.map((dataItem, index) => {
          return {
            ...dataItem,
            id: index,
          };
        }) || []
      }
      sx={{ "--DataGrid-overlayHeight": "600px" }}
    />
  );
};

export default EquityBasketTable;
